import { WidgetsSupportChatMain } from '@/widgets/support/chat';

export const PagesSupportChatMain = () => <WidgetsSupportChatMain />;
